export function canUseFilter(
  allowedFilterFields: string[] | null | undefined,
  field: string,
) {
  const normalizedField = field === 'handledBy' ? 'handledByIds' : field
  return (
    allowedFilterFields === null ||
    allowedFilterFields?.includes(normalizedField) === true
  )
}
